import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import CommunicationsInbox from '../components/CommunicationsInbox';

const SupplierInboxPage = () => {
  const [searchParams] = useSearchParams();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Get supplier info from URL parameters
  const token = searchParams.get('token');
  const supplierEmail = searchParams.get('email');
  const supplierId = searchParams.get('supplier');

  useEffect(() => {
    const loadSupplierInfo = async () => {
      try {
        if (!token || !supplierEmail || !supplierId) {
          setError('Missing required authentication parameters');
          return;
        }

        // TODO: Validate token and get supplier info
        // For now, using URL parameters
        setSupplier({
          id: supplierId,
          email: supplierEmail,
          name: supplierEmail.split('@')[0], // Extract name from email for now
        });

      } catch (error) {
        console.error('Error loading supplier info:', error);
        setError('Failed to authenticate. Please check your link.');
      } finally {
        setLoading(false);
      }
    };

    loadSupplierInfo();
  }, [token, supplierEmail, supplierId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your inbox...</p>
        </div>
      </div>
    );
  }

  if (error || !supplier) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center bg-white rounded-lg shadow-md p-8">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Access Error</h2>
          <p className="text-gray-600 mb-4">
            {error || 'Unable to access supplier inbox'}
          </p>
          <p className="text-sm text-gray-500">
            Please contact Pink Flamingo Interiors if you continue to have issues.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto py-4 px-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Supplier Communications</h1>
              <p className="text-gray-600">Welcome back, {supplier.name}</p>
            </div>
            <div className="text-sm text-gray-500">
              {supplier.email}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto py-8 px-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">
              All Your Project Communications
            </h2>
            <p className="text-gray-600 mt-1">
              Communications across all projects you're involved with
            </p>
          </div>
          
          <CommunicationsInbox
            userType="supplier"
            userId={supplier.id}
            projectId={null} // null = all projects for supplier
            userName={supplier.name}
            userEmail={supplier.email}
          />
        </div>

        {/* Help Section */}
        <div className="mt-8 bg-pink-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-pink-900 mb-2">Need Help?</h3>
          <p className="text-pink-800 mb-4">
            If you have questions about a project or need additional information, 
            you can send a message directly through this inbox.
          </p>
          <div className="text-sm text-pink-700">
            <p><strong>Contact Pink Flamingo Interiors:</strong></p>
            <p>📞 Phone: 0435 860 399</p>
            <p>📧 Email: team@pinkflamingointeriors.com.au</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierInboxPage;